<template>
  <div class="login-page">
    <div class="login-card ba_f">
      <div class="login-header">
        <h1>{{ $t("login.title") }}</h1>
        <p>{{ $t("login.subtitle") }}</p>
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="0"
        @keyup.enter.native="handleSubmit"
      >
        <el-form-item prop="username">
          <p class="field-label">{{ $t("login.userName") }}</p>
          <el-input
            v-model="form.username"
            autocomplete="username"
            :placeholder="$t('login.userNamePh')"
          />
        </el-form-item>
        <el-form-item prop="password">
          <p class="field-label">{{ $t("login.password") }}</p>
          <el-input
            v-model="form.password"
            type="password"
            show-password
            autocomplete="current-password"
            :placeholder="$t('login.passwordPh')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="login-btn"
            :loading="loading"
            @click="handleSubmit"
          >
            {{ $t("login.submit") }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="login-lang">
        <span class="color_9">{{ $t("lang.label") }}：</span>
        <el-select
          :value="currentLocale"
          size="small"
          style="width: 130px"
          @change="onLocaleChange"
        >
          <el-option :label="$t('lang.zhCN')" value="zh-CN" />
          <el-option :label="$t('lang.frFR')" value="fr-FR" />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/auth";
import { setAppLocale } from "@/i18n";
import { ensureSession, resetSessionCheck } from "@/utils/auth";

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      currentLocale: this.$i18n.locale,
      form: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    rules() {
      return {
        username: [
          {
            required: true,
            message: this.$t("login.userNameRequired"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.passwordRequired"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    onLocaleChange(lang) {
      setAppLocale(lang);
      this.currentLocale = lang;
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        try {
          const res = await login({
            username: this.form.username.trim(),
            password: this.form.password,
          });
          if (!res || res.code !== 1) {
            return;
          }
          resetSessionCheck();
          this.$store.commit("setAuthChecked", false);
          const sessionOk = await ensureSession();
          if (!sessionOk) {
            this.$baseMessage(this.$t("login.sessionFailed"), "error");
            return;
          }
          this.$baseMessage(res.msg || this.$t("login.success"), "success");
          const redirect = this.$route.query.redirect || "/index";
          this.$router.replace(redirect);
        } catch (e) {
          // 错误信息由 request 拦截器提示
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2f3447 0%, #4165d7 100%);
  padding: 24px;
}

.login-card {
  width: 100%;
  max-width: 420px;
  padding: 40px 36px 28px;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.login-header {
  margin-bottom: 28px;
  text-align: center;

  h1 {
    margin: 0 0 8px;
    font-size: 22px;
    color: #2f3447;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #909399;
  }
}

.field-label {
  margin: 0 0 8px;
  font-size: 14px;
  color: #606266;
}

.login-btn {
  width: 100%;
  height: 44px;
  margin-top: 8px;
  border-radius: 22px;
}

.login-lang {
  margin-top: 20px;
  text-align: center;
  font-size: 13px;
}
</style>
